<template>
  <div class="list-wrap">
    <div class="content" v-loading="loading">
      <div class="list-title">{{ title }}</div>
      <div class="list-content">
        <div
          class="list-item pointer"
          v-for="(item, index) in list"
          @click="goDetail(item)"
          :key="index"
        >
          <div class="list-text ell_one">{{ item.title }}</div>
          <div class="list-createTime">{{ item.modifyTime }}</div>
        </div>
        <div class="list-empty" v-if="list.length === 0">
          <img src="@/assets/img/good/noGood.png" />
          暂无相关资讯
        </div>
      </div>
      <el-pagination
        v-if="list.length > 0"
        :current-page="dataForm.page"
        :page-size="dataForm.limit"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        class="custom-pagination"
        layout="total, prev, pager, next, sizes, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      categoryId: '',
      dataForm: {
        page: 1,
        limit: 10
      },
      title: '',
      total: 0,
      list: [],
      loading: false
    }
  },
  created () {},
  methods: {
    init (categoryId, title) {
      this.title = title
      this.categoryId = categoryId
      this.dataForm.page = 1

      this.getList()
    },
    getList () {
      this.loading = true
      this.$http
        .get('/front/oms/openapi/shopping-content-information/list', {
          params: {
            categoryId: this.categoryId,
            ...this.dataForm
          }
        })
        .then(({ data: res }) => {
          if (res.code === 0 && res.data) {
            this.total = Number(res.data.total || 0)
            this.list = res.data.records || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    goDetail (item) {
      window.open(
        this.$router.resolve({
          path: '/contentInfoDetail',
          query: {
            id: item.id
          }
        }).href
      )
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.page = 1
      this.dataForm.limit = val
      this.getList()
    },
    // 当前页
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.list-wrap {
  flex: 1;
  margin-left: 40px;
  overflow: hidden;
  // word-wrap: break-word;

  .content {
    width: 100%;

    .list-title {
      // height: 56px;
      padding: 13px 16px;
      font-size: 24px;
      font-weight: bold;
      line-height: 33px;
      color: #333333;
    }

    .list-content {
      min-height: 560px;

      .list-item {
        display: flex;
        align-items: center;
        padding: 18px 16px;
        font-size: 14px;
        line-height: 19px;
        border-bottom: 1px solid #f5f6fa;

        .list-text {
          flex: 1;
          color: #2c2c2c;
          margin-right: 24px;
        }

        .list-createTime {
          color: #999999;
        }
      }

      .list-empty {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-height: 560px;
      }
    }

    .custom-pagination {
      padding: 20px 0;
      display: flex;
      align-items: center;
      border-top: 1px solid #f5f6fa;
      margin-top: -1px;

      /deep/.el-pagination__total {
        flex: 1;
        font-family: PingFang SC;
        font-size: 12px;
        color: #979799;

        &::after {
          content: "数据";
        }
      }

      /deep/ .el-pager {
        .number {
          padding: 0;
          margin: 0 2px;
          width: 32px;
          height: 32px;
          line-height: 30px;
          border-radius: 6px;
          background: #ffffff;
          color: #656566;
          border: 1px solid #efeff2;
          font-weight: normal;
          font-family: Arial;

          &.active {
            border-radius: 8px;
            border-color: #2a54d1;
            background: #2a54d1;
            color: #fff;
          }
        }
      }

      /deep/ .el-pagination__sizes,
      /deep/ .el-pagination__jump {
        height: 32px;
        line-height: 30px;
        display: flex;
        align-items: center;

        .el-input {
          input {
            border-radius: 6px;
            background: #f9f9fb;
            border: 1px solid #efeff2;
            height: 32px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
